import { IBookingCredentialsData } from './booking-credentials.model';
import { ContractError } from './models';

export interface IVoidTransactionQuote {
  pnr: string;
  country: string;
  gds: string;
  bookingCode: string;
  transactionId: string;
  officeId: string;
  overSign: IBookingCredentialsData;
  receivedFrom: string;
}

export interface IVoidTransactionState {
  currentProccess: voidTransactionStates;
  error: IVoidTransactionError;
}

export enum voidTransactionStates {
  initial = 'initial',
  makingQuery = 'makingQuery',
  success = 'success',
  error = 'error'
}

export interface IVoidTransactionError {
  info: ContractError;
  message: string;
}

export interface IVoidTransactionResponse {
  isVoid: boolean;
  messages: string[];
  ticketNumber: string;
}
